import { styled, css } from "../../../styled-components";

export const popAroundComponentDialogHeight = 48;

const LongPressActionBubblePositioning = styled.div<{ isAbove: boolean }>`
    user-select: none;

    position: absolute;
    ${p => (p.isAbove ? "bottom: 100%;" : "top: 100%;")}
    height: ${popAroundComponentDialogHeight}px;
    left: 50%;
    transform: translateX(-50%);

    max-width: 80%;
    animation-duration: 190ms;
    animation-name: lpab-showup;
    animation-timing-function: cubic-bezier(0.6, 0.78, 0.12, 1.55);
    animation-fill-mode: forwards;

    color: ${p => p.theme.baseColor};

    @keyframes lpab-showup {
        0% {
            opacity: 0;
            transform: translateX(-50%) scale(0.67);
        }
        100% {
            opacity: 1;
            transform: translateX(-50%) scale(1);
        }
    }

    .lpab-message {
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .lpab-bubble-general {
        padding-left: ${p => p.theme.pageMarginMedium}px;
        padding-right: ${p => p.theme.pageMarginMedium}px;
        -webkit-tap-highlight-color: transparent;

        display: flex;
        flex-direction: column;
        justify-content: center;
        align-content: center;

        ${p => p.theme.fontStyles.Body5}

        height: 42px;
        max-width: 100%;
    }
`;

export const LongPressActionBubbleStyle = styled(LongPressActionBubblePositioning)<{ hover: boolean }>`
    display: flex;
    flex-direction: column;
    align-items: center;

    --bubble-color: ${p => p.theme.fgColorOpaque};
    ${p =>
        p.hover &&
        css`
            --bubble-color: ${q => q.theme.listItem.selectedColorOpaque};
            color: ${q => q.theme.fgColorOpaque};
        `}

    .lpab-bottom-triangle {
        width: 0;
        height: 0;
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
        border-top: 6px solid var(--bubble-color);
    }

    .lpab-top-triangle {
        width: 0;
        height: 0;
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
        border-bottom: 6px solid var(--bubble-color);
    }

    .lpab-bubble-full {
        border-radius: 6px;
        background-color: var(--bubble-color);
    }
`;

export const LongPressTwoActionBubbleWrapper = styled(LongPressActionBubblePositioning)<{
    leftHover: boolean;
    rightHover: boolean;
}>`
    display: flex;
    flex-direction: row;

    .lpab-left-side-wrapper {
        --left-bubble-color: ${p => p.theme.fgColorOpaque};

        ${p =>
            p.leftHover &&
            css`
                --left-bubble-color: ${q => q.theme.listItem.selectedColorOpaque};
                color: ${q => q.theme.fgColorOpaque};
            `};

        flex-flow: row-reverse;
        justify-content: start;
        border-right: 0.5px solid ${p => p.theme.baseColor};
    }

    .lpab-right-side-wrapper {
        --right-bubble-color: ${p => p.theme.fgColorOpaque};

        ${p =>
            p.rightHover &&
            css`
                --right-bubble-color: ${q => q.theme.listItem.selectedColorOpaque};
                color: ${q => q.theme.fgColorOpaque};
            `};

        justify-content: start;
        border-left: 0.5px solid ${p => p.theme.baseColor};
    }

    .lpab-left-top-triangle {
        width: 6px;
        border-left: 6px solid transparent;
        border-bottom: 6px solid var(--left-bubble-color);
    }

    .lpab-right-top-triangle {
        width: 6px;
        border-right: 6px solid transparent;
        border-bottom: 6px solid var(--right-bubble-color);
    }

    .lpab-left-bottom-triangle {
        width: 6px;
        border-left: 6px solid transparent;
        border-top: 6px solid var(--left-bubble-color);
    }

    .lpab-right-bottom-triangle {
        width: 6px;
        border-right: 6px solid transparent;
        border-top: 6px solid var(--right-bubble-color);
    }

    .lpab-left-triangle-container {
        display: flex;
        flex-direction: column;
        flex-flow: row-reverse;
    }

    .lpab-right-triangle-container {
        display: flex;
        flex-direction: column;
    }

    .lpab-bubble-left {
        border-radius: 6px 0px 0px 6px;
        background-color: var(--left-bubble-color);
    }

    .lpab-bubble-right {
        border-radius: 0px 6px 6px 0px;
        background-color: var(--right-bubble-color);
    }
`;
